import React from 'react';
import { motion, type HTMLMotionProps } from 'motion/react';

export type AnimateInProps = React.PropsWithChildren<HTMLMotionProps<'div'>> & {
  shimmer?: boolean;
};

export const AnimateIn = ({ className, children, shimmer, ...rest }: AnimateInProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, translateY: 30 }}
      animate={{ opacity: 1, translateY: 0 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      viewport={{ once: true }}
      className={className}
      {...rest}
    >
      {children}
      {shimmer && (
        <>
          <div className="absolute inset-0 pointer-events-none overflow-hidden hidden">
            <div
              className="absolute inset-0 animate-shimmer"
              style={{
                background:
                  'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.5) 50%, transparent 100%)',
                backgroundSize: '200% 100%'
              }}
            />
          </div>
          <div
            className="absolute inset-0 rounded-lg animate-border-shimmer"
            style={{
              background: 'linear-gradient(90deg, transparent, #2563eb80, transparent)',
              backgroundSize: '200% 100%',
              mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
              maskComposite: 'exclude',
              padding: '2px'
            }}
          />
        </>
      )}
    </motion.div>
  );
};
